import { SystemError } from "../../error";
import { Change, NumberIdentity, Version } from "../../value-objects";
import { BaseTenantEntity, } from "../base-tenant-entity";
export class LogixApiClientEntity extends BaseTenantEntity {
    constructor(value) {
        super(value);
    }
    get logixApiClientId() {
        return this.v.logixApiClientId;
    }
    validator(_) {
        throw new SystemError.NotImplemented("Method not implemented.");
    }
    static newLogixApiClient(v) {
        const args = {
            id: new NumberIdentity(v.id),
            tenantId: new NumberIdentity(v.tenantId),
            logixApiClientId: v.logixApiClientId,
            roleId: v.roleId ? new NumberIdentity(v.roleId) : undefined,
            expiredAt: v.expiredAt,
            isDisabled: v.isDisabled,
            disabledAt: v.disabledAt,
            change: Change.hasChange(v) ? new Change(v) : undefined,
            version: v.version !== undefined
                ? new Version({
                    version: v.version,
                })
                : undefined,
        };
        return new LogixApiClientEntity(args);
    }
    static schema() {
        return {
            ...NumberIdentity.schema(),
            tenantId: NumberIdentity.schema().id,
        };
    }
}
//# sourceMappingURL=logix-api-client-entity.js.map